<template>
  <div class="header" :class="{ 'scrolled': isScrolled }">
    <div class="w1024 flex_header">
      <div>
        <img v-if="!isScrolled" :src="imgUrl" style="width: 150px;" alt="">
        <img v-else :src="loginImg1" style="width: 150px;" alt="">
      </div>
      <div style="width: 600px;">
        <ul class="d-flex space-between">
          <li @click="goHome()"><span class="nav-link">主页</span></li>
          <li @click="goAbout()"><span class="nav-link">公司概要</span></li>
          <li @click="goBrand()"><span class="nav-link">业务领域</span></li>
          <li @click="goAbout()"><span class="nav-link">投资者关系</span></li>
          <li @click="goAbouts()"><span class="nav-link">公众平台</span></li>
          <li  @click="energy()"><span class="nav-link">业务布局</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import loginImg from '@/images/index-login.png'
import loginImg1 from '@/images/login.png'
export default {
  name: 'IndxHead',
  props: {
    msg: String
  },
  data() {
    return {
      isScrolled: false,
      imgUrl: loginImg,
      loginImg1: loginImg1
    }
  },
  mounted() {
    // this.detectDevice();
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    
    // 检查是否已经在目标路由
    isCurrentRoute(path) {
      return this.$route.path === path;
    },
    goHome() {
      if (!this.isCurrentRoute('/')) {
        this.$router.push('/');
      }
    },
    goAbout() {
      if (!this.isCurrentRoute('/about')) {
        this.$router.push('/about');
      }
    },
    energy(){
      if (!this.isCurrentRoute('/energy')) {
        this.$router.push('/energy');
      }
    },
    goAbouts() {
      const route = this.$router.resolve({ path: '/abouts' });
      window.open(route.href, '_blank');

      // if (!this.isCurrentRoute('/abouts')) {
      //   this.$router.push('/abouts');
      // }
    },
    goNews() {
      if (!this.isCurrentRoute('/news')) {
        this.$router.push('/news');
      }
    },
    goTalent() {
      if (!this.isCurrentRoute('/talent')) {
        this.$router.push('/talent');
      }
    },

    goBrand() {
      if (!this.isCurrentRoute('/brand')) {
        this.$router.push('/brand');
      }
    },
    handleScroll() {
      // 当滚动距离大于50px时添加背景，可以根据需要调整这个值
      this.isScrolled = window.scrollY > 50;
    }
  }
}
</script>

<style scoped>
.w100 {
  width: 100%;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 50px;
  font-size: 14px;
  padding: 16px 0;
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  color: #ffffff;
}

/* 滚动时的样式 */
.header.scrolled {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  color: #333333;
}

.flex_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease-in-out;
}

/* 菜单项样式 */
.d-flex {
  display: flex;
}

.space-between {
  justify-content: space-between;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 10px 20px;
  cursor: pointer;
  transition: color 0.3s ease;
  font-weight: 500;
  color: inherit;
  /* 继承父元素的颜色 */
}

/* 未滚动时的样式（顶部位置） */
.header:not(.scrolled) {
  background-color: transparent;
  color: #ffffff;
}

.header:not(.scrolled) li:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* 滚动时的样式 */
.header.scrolled {
  background-color: rgba(255, 255, 255, 0.95);
  color: #333333;
}

.header.scrolled li:hover {
  color: #007bff;
}

/* 确保图片在滚动时也能适应颜色变化 */
.header:not(.scrolled) img {
  filter: brightness(0) invert(1);
  /* 将图片变为白色 */
}

.header.scrolled img {
  filter: none;
  /* 滚动时恢复原色 */
}

/* shubjingg */
.nav-link {
  position: relative;
  padding: 5px 0;
  transition: all 0.3s ease;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: currentColor;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

li:hover .nav-link::after {
  width: 80%;
}

/* 未滚动时的特殊效果 */
.header:not(.scrolled) .nav-link::after {
  background-color: #ffffff;
}

.header.scrolled .nav-link::after {
  background-color: #007bff;
}
</style>